/**
 * METS Enterprise group policy.
 *
 * Routes and hamburger menu must stay in sync with this list.
 * Staff always bypass via ProtectedRoute allowStaff.
 *
 * Assign users in Django admin → Groups → "METS Enterprise"
 * (Supervisor retains access for existing operators).
 */

export const METS_ENTERPRISE_ALLOWED_GROUPS = Object.freeze([
  'METS Enterprise',
  'Supervisor',
]);

/** Hamburger labels + paths (order matches product IA). */
export const METS_ENTERPRISE_NAV = Object.freeze([
  { key: 'mets-overview', path: '/mets', label: 'METS Enterprise' },
  { key: 'mets-fleet', path: '/mets/fleet', label: 'Fleet Readiness' },
  { key: 'mets-maintenance', path: '/mets/maintenance', label: 'Maintenance Production' },
  { key: 'mets-constraints', path: '/mets/constraints', label: 'Constraints & Decisions' },
  { key: 'mets-scenarios', path: '/mets/scenarios', label: 'Scenario Comparison' },
  { key: 'mets-reliability', path: '/mets/reliability', label: 'Reliability' },
  { key: 'mets-quality', path: '/mets/quality', label: 'Quality & Compliance' },
  { key: 'mets-material', path: '/mets/material', label: 'Material Readiness' },
  { key: 'mets-workforce', path: '/mets/workforce', label: 'Workforce' },
]);

/** All ProtectedRoute paths including nested fleet detail. */
export const METS_ENTERPRISE_PATHS = Object.freeze([
  '/mets',
  '/mets/fleet',
  '/mets/fleet/:aircraftId',
  '/mets/maintenance',
  '/mets/constraints',
  '/mets/scenarios',
  '/mets/reliability',
  '/mets/quality',
  '/mets/material',
  '/mets/workforce',
]);

/**
 * @param {{ isStaff?: boolean, groups?: string[] }} auth
 * @returns {boolean}
 */
export function canAccessMetsEnterprise({ isStaff = false, groups = [] } = {}) {
  if (isStaff) return true;
  const safeGroups = Array.isArray(groups) ? groups : [];
  return METS_ENTERPRISE_ALLOWED_GROUPS.some((name) => safeGroups.includes(name));
}

const metsEnterpriseAccess = {
  METS_ENTERPRISE_ALLOWED_GROUPS,
  METS_ENTERPRISE_NAV,
  METS_ENTERPRISE_PATHS,
  canAccessMetsEnterprise,
};

export default metsEnterpriseAccess;
